<div
  class="dense-grid"
  [class.dense-grid--multi-day]="isMultiDay"
>
  @if (loading) {
    <div class="dense-grid__loader">
      <div class="dense-grid__spinner"></div>
    </div>
  } @else if (columns.length === 0 || rows.length === 0) {
    <div
      style="
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.5rem;
        color: #8f9596;
        height: 100%;
      "
    >
      <span style="font-size: 1.25rem; font-weight: 600; color: #374151"
        >Nenhum dado encontrado</span
      >
      <span style="font-size: 0.9rem"
        >Não há horários disponíveis para as agendas selecionadas</span
      >
    </div>
  } @else {
    <div
      #scrollContainer
      class="dense-grid__scroll"
      [style.--column-count]="columns.length"
      (dragover)="onScrollContainerDragOver($event)"
    >
      <!-- Multi-day: date row spans all schedules of the same day -->
      @if (isMultiDay) {
        <div class="dense-grid__head-row dense-grid__head-row--date">
          <div class="dense-grid__corner"></div>
          @for (group of dateGroups; track trackByDateGroup($index, group)) {
            <div
              class="dense-grid__date-cell"
              [style.grid-column]="'span ' + group.span"
            >
              <span class="dense-grid__date-weekday">{{ group.weekdayLabel }}</span>
              <span class="dense-grid__date-day">{{ group.dayLabel }}</span>
            </div>
          }
        </div>
      }

      <!-- Schedule header row (colored bar on the bottom) -->
      <div class="dense-grid__head-row dense-grid__head-row--schedule">
        @if (!isMultiDay) {
          <div class="dense-grid__corner"></div>
        } @else {
          <div class="dense-grid__corner dense-grid__corner--filler"></div>
        }
        @for (column of columns; track trackByColumnKey($index, column)) {
          <div class="dense-grid__head-cell">
            <div class="dense-grid__head-text">
              <span
                class="dense-grid__head-name"
                [title]="column.scheduleName"
                >{{ column.scheduleName }}</span
              >
              <div class="dense-grid__head-counts">
                <span>{{ column.scheduled }} agendados</span>
                <span>{{ column.free }} livres</span>
              </div>
            </div>
            <div
              class="dense-grid__head-bar"
              [style.background-color]="column.color || '#6c5ce7'"
            ></div>
          </div>
        }
      </div>

      <!-- Time rows -->
      @for (row of rows; track trackByTime($index, row)) {
        <div class="dense-grid__row">
          <div
            class="dense-grid__time"
            [class.dense-grid__time--full]="isFullHour(row.time)"
          >
            {{ row.time }}
          </div>
          @for (column of columns; track trackByColumnKey($index, column)) {
            <div
              class="dense-grid__cell"
              [class.dense-grid__cell--drop]="
                dragOverKey === column.key &&
                dragOverTime === row.time &&
                !isDropOnFreeCell(column.key, row.time)
              "
              [class.dense-grid__cell--drop-on-free]="isDropOnFreeCell(column.key, row.time)"
              [class.dense-grid__cell--clickable]="canCreateInCell(column, row)"
              (dragover)="onDragOver($event, column.key, row.time)"
              (dragleave)="onDragLeave()"
              (drop)="onDrop($event, column, row.time)"
              (click)="canCreateInCell(column, row) && onEmptyCellClick(column, row)"
            >
              @if (row.cellsByKey[column.key].length === 0) {
                @if (canCreateInCell(column, row)) {
                  <div
                    class="dense-grid__ghost-card"
                    aria-hidden="true"
                  >
                    <span class="dense-grid__slot-time dense-grid__slot-time--inside">{{
                      row.time
                    }}</span>
                    <div class="dense-grid__ghost-body">
                      <span class="dense-grid__ghost-icon">+</span>
                      <span class="dense-grid__ghost-label">Inserir encaixe</span>
                    </div>
                  </div>
                } @else {
                  <span class="dense-grid__slot-time">{{ row.time }}</span>
                }
              } @else {
                @for (
                  cell of row.cellsByKey[column.key];
                  track trackByCellSlot($index, cell);
                  let cellIndex = $index
                ) {
                  @if (
                    dropPreview &&
                    dropPreview.columnKey === column.key &&
                    dropPreview.rowTime === row.time &&
                    dropPreview.anchorIndex === cellIndex &&
                    dropPreview.position === 'above'
                  ) {
                    <div class="dense-grid__drop-indicator"></div>
                  }
                  @switch (cell.type) {
                    @case ('appointment') {
                      <div
                        class="dense-card dense-card--appointment"
                        [class.dense-card--locked]="isLocked(cell.slot)"
                        [class.dense-card--dragging]="
                          draggingApptId === asAppointment(cell.slot).id
                        "
                        [attr.draggable]="isAppointmentDraggable(asAppointment(cell.slot))"
                        (dragstart)="onDragStart($event, asAppointment(cell.slot))"
                        (dragend)="onDragEnd()"
                        (click)="onCardClick(cell)"
                      >
                        <div
                          class="dense-card__bar"
                          [style.background-color]="statusColor(asAppointment(cell.slot))"
                        ></div>
                        <div class="dense-card__body">
                          <div class="dense-card__name">
                            {{ asAppointment(cell.slot).patient?.name || '—' }}
                          </div>
                          @if (procedureName(asAppointment(cell.slot))) {
                            <div class="dense-card__proc">
                              {{ procedureName(asAppointment(cell.slot)) }}
                            </div>
                          }
                          @if (showObservation(asAppointment(cell.slot))) {
                            <div
                              class="dense-card__obs"
                              [title]="asAppointment(cell.slot).observation"
                            >
                              <span class="material-symbols-outlined dense-card__obs-icon"
                                >notes</span
                              >
                              <span class="dense-card__obs-text">{{
                                asAppointment(cell.slot).observation
                              }}</span>
                            </div>
                          }
                          <div class="dense-card__foot">
                            <span class="dense-card__time">{{ cell.startTime }}</span>
                            <span class="dense-card__foot-icons">
                              @if (cell.canGroupWithNeighbors) {
                                <button
                                  type="button"
                                  class="dense-card__chain-btn dense-card__chain-btn--join"
                                  title="Agrupar com agendamentos vizinhos"
                                  (click)="onGroupClick($event, cell)"
                                >
                                  <span class="material-symbols-outlined">link</span>
                                </button>
                              }
                              <span
                                class="dense-card__status-dot"
                                role="img"
                                [attr.aria-label]="statusName(asAppointment(cell.slot))"
                                ocTooltip
                                [content]="statusName(asAppointment(cell.slot))"
                                [style.background-color]="statusColor(asAppointment(cell.slot))"
                              ></span>
                            </span>
                          </div>
                        </div>
                        @if (isLocked(cell.slot)) {
                          <div class="dense-card__lock-overlay">
                            <span class="material-symbols-outlined">lock_person</span>
                          </div>
                        }
                      </div>
                    }
                    @case ('free') {
                      <div
                        class="dense-card dense-card--free"
                        [class.dense-card--free-locked]="isLocked(cell.slot)"
                        (click)="onCardClick(cell)"
                      >
                        <span class="dense-card__free-time">{{ cell.startTime }}</span>
                        <div class="dense-card__free-meta">
                          @if (cell.services?.length) {
                            <span
                              class="dense-card__free-services"
                              [title]="servicesLabel(cell.services)"
                              >{{ servicesLabel(cell.services) }}</span
                            >
                          }
                          @if (cell.observation) {
                            <span
                              class="dense-card__free-obs"
                              [title]="cell.observation"
                              >{{ cell.observation }}</span
                            >
                          }
                          @if (!cell.services?.length && !cell.observation) {
                            <span class="dense-card__free-label">Livre</span>
                          }
                        </div>
                        @if (isLocked(cell.slot)) {
                          <div class="dense-card__lock-overlay">
                            <span class="material-symbols-outlined">lock_person</span>
                          </div>
                        }
                      </div>
                    }
                    @case ('blocked') {
                      <div
                        class="dense-card dense-card--blocked"
                        (click)="onCardClick(cell)"
                      >
                        <div class="dense-card__blocked-top">
                          <span class="dense-card__blocked-time">{{ cell.startTime }}</span>
                          <span class="material-symbols-outlined dense-card__blocked-icon"
                            >block</span
                          >
                        </div>
                        <span
                          class="dense-card__blocked-label"
                          [title]="cell.observation || 'Bloqueado'"
                        >
                          {{ cell.observation || 'Bloqueado' }}
                        </span>
                      </div>
                    }
                    @case ('group') {
                      <div
                        class="dense-card dense-card--group dense-card--appointment"
                        [class.dense-card--dragging]="
                          draggingApptId === asAppointment(cell.slot).id
                        "
                        [attr.draggable]="isAppointmentDraggable(asAppointment(cell.slot))"
                        (dragstart)="onGroupDragStart($event, cell)"
                        (dragend)="onDragEnd()"
                        (click)="onGroupCardClick(cell, column)"
                      >
                        <div
                          class="dense-card__bar"
                          [style.background-color]="statusColor(asAppointment(cell.slot))"
                        ></div>
                        <div class="dense-card__body">
                          <div class="dense-card__name">
                            {{ asAppointment(cell.slot).patient?.name || '—' }}
                            <span class="dense-card__group-badge">
                              {{ cell.groupSlots?.length }}
                            </span>
                          </div>
                          <ul class="dense-card__group-list">
                            @for (apt of cell.groupSlots; track apt.id) {
                              <li class="dense-card__group-list-item">
                                <span class="dense-card__group-list-time">{{
                                  formatTime(apt.start)
                                }}</span>
                                <span class="dense-card__group-list-proc">{{
                                  procedureName(apt) || 'Sem procedimento'
                                }}</span>
                              </li>
                            }
                          </ul>
                          <div class="dense-card__foot">
                            <span class="dense-card__time">{{ groupTimeRange(cell) }}</span>
                            <span class="dense-card__foot-icons">
                              <button
                                type="button"
                                class="dense-card__chain-btn dense-card__chain-btn--break"
                                title="Desagrupar"
                                (click)="onUngroupClick($event, cell)"
                              >
                                <span class="material-symbols-outlined">link_off</span>
                              </button>
                              <span
                                class="dense-card__status-dot"
                                role="img"
                                [attr.aria-label]="statusName(asAppointment(cell.slot))"
                                ocTooltip
                                [content]="statusName(asAppointment(cell.slot))"
                                [style.background-color]="statusColor(asAppointment(cell.slot))"
                              ></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('continuation') {
                      <div
                        class="dense-card dense-card--continuation"
                        [title]="
                          'Indisponível — ocupado pelo agendamento de ' +
                          cell.ownerName +
                          ' (início ' +
                          cell.ownerStartTime +
                          ')'
                        "
                      >
                        <div class="dense-card__continuation-top">
                          <span class="dense-card__continuation-time">{{ cell.startTime }}</span>
                          <span class="material-symbols-outlined dense-card__continuation-icon"
                            >schedule</span
                          >
                        </div>
                        <span class="dense-card__continuation-text">
                          Indisponível — agendamento de {{ cell.ownerStartTime }}
                        </span>
                      </div>
                    }
                  }
                  @if (
                    dropPreview &&
                    dropPreview.columnKey === column.key &&
                    dropPreview.rowTime === row.time &&
                    dropPreview.anchorIndex === cellIndex &&
                    dropPreview.position === 'below'
                  ) {
                    <div class="dense-grid__drop-indicator"></div>
                  }
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<!-- Confirmation modal: fit-in OR snap-confirm depending on isFitIn -->
<oc-modal
  [isOpen]="!!pendingMove"
  [ocTitle]="
    pendingMove ? (pendingMove.isFitIn ? 'Criar como encaixe?' : 'Confirmar transferência?') : ''
  "
  ocSize="small"
  ocBgColor="white"
  (ocOnClose)="cancelPendingMove()"
>
  @if (pendingMove) {
    <div class="dense-modal__patient">
      <span class="material-symbols-outlined">person</span>
      <div class="dense-modal__patient-text">
        <span class="dense-modal__patient-label">Paciente</span>
        <span class="dense-modal__patient-name">{{ pendingMove.patientName }}</span>
      </div>
    </div>
    <div class="dense-move-summary">
      <div class="dense-move-summary__col">
        <span class="dense-move-summary__label">De</span>
        <span class="dense-move-summary__time">{{ pendingMove.sourceTime }}</span>
        <span class="dense-move-summary__schedule">{{ pendingMove.sourceScheduleName }}</span>
      </div>
      <span class="material-symbols-outlined dense-move-summary__arrow">arrow_forward</span>
      <div class="dense-move-summary__col">
        <span class="dense-move-summary__label">Para</span>
        <input
          #targetTimeInput
          class="dense-move-summary__time-input"
          type="time"
          [value]="pendingMove.targetTime"
          (change)="onPendingMoveTargetTimeChange(targetTimeInput.value)"
          [class.dense-move-summary__time-input--error]="!!pendingMoveTimeError"
        />
        <span class="dense-move-summary__schedule">{{ pendingMove.targetScheduleName }}</span>
      </div>
    </div>
    @if (pendingMoveTimeError) {
      <p class="dense-move-summary__error">{{ pendingMoveTimeError }}</p>
    }
    @if (pendingMove.isFitIn) {
      <oc-message
        ocColor="purple"
        ocIcon="warning"
      >
        Este horário já está ocupado. O agendamento será inserido como
        <strong>encaixe</strong>.
      </oc-message>
      @if (
        pendingMove.coveredMinutes > 0 && pendingMove.coveredMinutes < pendingMove.totalMinutes
      ) {
        <oc-message
          ocColor="purple"
          ocIcon="warning"
        >
          Cabem apenas {{ pendingMove.coveredMinutes }} de {{ pendingMove.totalMinutes }} minutos.
        </oc-message>
      }
    } @else if (!pendingMove.isCleanMove) {
      <oc-message
        ocColor="purple"
        ocIcon="warning"
      >
        Este horário não está pré-configurado na agenda de destino. A transferência criará o
        agendamento fora do template padrão.
      </oc-message>
    }
    <oc-modal-footer>
      <button
        class="oc button gray-1"
        (click)="cancelPendingMove()"
      >
        Cancelar
      </button>
      <button
        class="oc button g-1"
        [disabled]="!!pendingMoveTimeError"
        (click)="confirmPendingMove()"
      >
        {{ pendingMove.isFitIn ? 'Confirmar encaixe' : 'Confirmar transferência' }}
      </button>
    </oc-modal-footer>
  }
</oc-modal>

<!-- Cascade shift modal: confirm pushing neighbors +1min to make room -->
<oc-modal
  [isOpen]="!!pendingShiftMove"
  ocTitle="Inserir entre agendamentos?"
  ocIcon="low_priority"
  ocSize="small"
  ocBgColor="white"
  (ocOnClose)="cancelPendingShiftMove()"
>
  @if (pendingShiftMove) {
    <p>
      O agendamento de <strong>{{ pendingShiftMove.movingAppointment.patient?.name }}</strong> será
      inserido em <strong>{{ formatTime(pendingShiftMove.newStart) }}</strong
      >.
    </p>
    <p class="dense-modal__hint">
      Para abrir espaço, {{ pendingShiftMove.shiftMoves.length }} agendamento(s) seguinte(s) serão
      deslocados em +1 minuto.
    </p>
    <ul class="dense-group-pick-list">
      @for (m of pendingShiftMove.shiftMoves; track m.appointment.id) {
        <li class="dense-group-pick-item">
          <label>
            <span class="dense-group-pick-time">
              {{ formatTime(m.oldStart) }} → {{ formatTime(m.newStart) }}
            </span>
            <span class="dense-group-pick-proc">
              {{ m.appointment.patient?.name || '—' }}
            </span>
          </label>
        </li>
      }
    </ul>
    <oc-modal-footer>
      <button
        class="oc button gray-1"
        (click)="cancelPendingShiftMove()"
      >
        Cancelar
      </button>
      <button
        class="oc button g-1"
        (click)="confirmPendingShiftMove()"
      >
        Confirmar e deslocar
      </button>
    </oc-modal-footer>
  }
</oc-modal>

<!-- Group move modal: choose move-all or pick-some -->
@if (pendingGroupMove) {
  <div
    class="dense-modal-overlay"
    (click)="cancelGroupMove()"
  >
    <div
      class="dense-modal"
      (click)="$event.stopPropagation()"
    >
      <div class="dense-modal__header">
        <span class="material-symbols-outlined dense-modal__icon">drag_indicator</span>
        <h3 class="dense-modal__title">
          @if (pendingGroupMove.mode === 'choose') {
            Transferir grupo
          } @else {
            Selecionar agendamentos para transferir
          }
        </h3>
      </div>
      <div class="dense-modal__body">
        @if (pendingGroupMove.mode === 'choose') {
          <p>
            O grupo tem <strong>{{ pendingGroupMove.appointments.length }}</strong> agendamentos do
            paciente <strong>{{ pendingGroupMove.appointments[0]?.patient?.name }}</strong
            >.
          </p>
          <p>O que você quer transferir?</p>
        } @else {
          <p>Marque os agendamentos que devem ser transferidos:</p>
          <ul class="dense-group-pick-list">
            @for (apt of pendingGroupMove.appointments; track apt.id) {
              <li class="dense-group-pick-item">
                <label>
                  <input
                    type="checkbox"
                    [checked]="isGroupMoveSelected(apt.id)"
                    (change)="toggleGroupMoveSelection(apt.id, $any($event.target).checked)"
                  />
                  <span class="dense-group-pick-time">{{ formatTime(apt.start) }}</span>
                  <span class="dense-group-pick-proc">
                    {{ procedureName(apt) || 'Sem procedimento' }}
                  </span>
                </label>
              </li>
            }
          </ul>
        }
      </div>
      <div class="dense-modal__footer">
        @if (pendingGroupMove.mode === 'choose') {
          <button
            type="button"
            class="dense-modal__btn dense-modal__btn--ghost"
            (click)="cancelGroupMove()"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="dense-modal__btn dense-modal__btn--ghost"
            (click)="enterGroupMovePickSome()"
          >
            Transferir apenas alguns
          </button>
          <button
            type="button"
            class="dense-modal__btn dense-modal__btn--primary"
            (click)="chooseGroupMoveAll()"
          >
            Transferir todos
          </button>
        } @else {
          <button
            type="button"
            class="dense-modal__btn dense-modal__btn--ghost"
            (click)="cancelGroupMove()"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="dense-modal__btn dense-modal__btn--primary"
            (click)="confirmGroupMovePickSome()"
          >
            Transferir selecionados
          </button>
        }
      </div>
    </div>
  </div>
}

<!-- Appointment details drawer (right side) -->
<oc-drawer
  ocTitle="Detalhes do agendamento"
  ocWidth="420px"
  [isOpen]="!!openDetailsDrawer"
  (ocOnClose)="onDetailsClose()"
>
  @if (openDetailsDrawer) {
    @if (openDetailsDrawer.fromGroupKey) {
      <oc-breadcrumb
        class="dense-drawer__breadcrumb"
        [ocItems]="detailsBreadcrumbItems"
        (ocCrumbClick)="onDetailsBack()"
      />
    }
    <app-appointment-details
      [appointment]="openDetailsDrawer.appointment"
      [schedules]="schedules"
      [isLockedByOther]="isLockedByOther(openDetailsDrawer.appointment)"
      (historyClick)="onDetailsHistoryClick($event)"
      (openAppointmentClick)="onDetailsOpenAppointmentClick($event)"
    />
  }
</oc-drawer>

<!-- Group drawer (right side) -->
<oc-drawer
  ocWidth="420px"
  [isOpen]="!!openGroupDrawer"
  (ocOnClose)="onCloseGroupDrawer()"
>
  <oc-drawer-header>
    <div class="dense-drawer__group-header">
      <h3 class="dense-drawer__group-title">Grupo de agendamentos</h3>
      <button
        type="button"
        class="dense-drawer__action-btn"
        title="Desagrupar todos"
        (click)="onUngroupFromDrawer()"
      >
        <span class="material-symbols-outlined">link_off</span>
        Desagrupar
      </button>
      <button
        type="button"
        class="dense-drawer__close-btn"
        title="Fechar"
        (click)="onCloseGroupDrawer()"
      >
        <span class="material-symbols-outlined md-18">close</span>
      </button>
    </div>
  </oc-drawer-header>
  @if (openGroupDrawer) {
    <div class="dense-drawer__group-body">
      <p class="dense-drawer__hint">
        Paciente: <strong>{{ openGroupDrawer.appointments[0]?.patient?.name }}</strong>
      </p>
      <ul class="dense-drawer__list">
        @for (apt of openGroupDrawer.appointments; track apt.id) {
          <li
            class="dense-drawer__item"
            (click)="onDrawerItemClick(apt)"
          >
            <div
              class="dense-drawer__item-bar"
              role="img"
              [attr.aria-label]="statusName(apt)"
              [style.background-color]="statusColor(apt)"
            ></div>
            <div class="dense-drawer__item-body">
              <div class="dense-drawer__item-time">{{ formatTime(apt.start) }}</div>
              <div class="dense-drawer__item-proc">
                {{ procedureName(apt) || 'Sem procedimento' }}
              </div>
              @if (apt.status?.name) {
                <div class="dense-drawer__item-status">{{ apt.status?.name }}</div>
              }
            </div>
            <button
              type="button"
              class="dense-drawer__item-remove"
              title="Remover do grupo"
              (click)="$event.stopPropagation(); onRemoveFromGroup(apt)"
            >
              <span class="material-symbols-outlined">link_off</span>
            </button>
          </li>
        }
      </ul>
    </div>
  }
</oc-drawer>
